<template>
  <div class="ECPMSwitch" :data-ecpm="this.$store.state.ecpmActionsLayer" >
    <div class="ECPMSwitch__treatyTitleLabel" v-on:click="toggleEcpmActionsLayer">
      <img :src="require('@/assets/icons/ecpm_map_icon.png')" class="IconButton__icon" alt="">
      <span class="hide-md">{{ words[this.lang].general.EcpmActions }}</span>
    </div>
    <span class="Checkbox" v-on:click="toggleEcpmActionsLayer"></span>
  </div>
</template>

<script>
import { words } from '@/constants/lang'

export default {
  name: 'ECPMSwitch',
  data: function() {
    return {
      words,
    }
  },
  methods: {
    toggleEcpmActionsLayer() {
      this.$store.commit('toggleEcpmActionsLayer')
    }
  },
  computed: {
    lang: function () {
      return this.$store.state.language.lang
    }
  }
}
</script>

<style lang="less">

  @import "../less/_var.less";

  .ECPMSwitch {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    border-right: solid 2px #666;
    padding: 7px 12px 6px 11px;
    border-radius: 3px 2px 2px 3px;
    width: fit-content;
    position: absolute;
    top: 15px;
    right: 15px;

    #app[data-infopanel=true] & {
      right: calc(15px + 380px);
    }

    margin: 0 auto;
    background: #fff;
    box-shadow: 0 3px 14px -3px rgba(0, 0, 0, 0.15);
    transition: all .1s ease-out;

    img {
      max-height: 26px;
      max-width: 20px;
      margin-right: 8px;
    }

    .Checkbox {
      border: solid 1px #ccc;
      border-radius: 7px;
      height: 12px;
      width: 30px;
      min-width: 28px;
      position: relative;
      margin: 0;
      cursor: pointer;
      margin-left: 10px;
      transform: scale(0.9);
      background: #eee;

      &::after {
          content: "";
          border-radius: 50%;
          height: 19px;
          width: 19px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          background: #666;
          position: absolute;
          transition: transform 0.15s ease-out;
          top: -4px;
      }
    }

    .Checkbox {
      &::after {
        transform: translateX(-5px);
      }
    }

    &[data-ecpm="true"] {
      border-right: solid 2px #f04e54;
      .Checkbox {
        background: #fff;
        &::after {
          transform: translateX(17px);
          background: @color-primary;
        }
      }
    }

    .ECPMSwitch__treatyTitleLabel {
      display: inline-flex;
      flex-flow: row nowrap;
      align-items: center;
      font-family: @font-secondary;
      font-weight: 400;
      font-size: 0.8em;
      cursor: pointer;
      text-align: center;
    }
  }
</style>
